import { type AnchorHTMLAttributes } from 'react';
import { InlineLink } from 'InlineLink';
import { type LinkTarget } from 'NavigationHelpers';
import { linkStyles } from './MessageSources/shared';

// Renders markdown links in TutorBot messages via InlineLink (the app-wide link primitive)
// rather than a plain <a>. This routes in-app (relative) links through the router so they
// navigate as a single-page transition — which is what makes them work under the hash router
// in the mobile (Capacitor) app instead of triggering a broken full-page navigation. External,
// mailto, and tel links flow through the same InlineLink -> useLinkParams pipeline unchanged.
export function MarkdownStyledLink({ href, target, children }: AnchorHTMLAttributes<HTMLAnchorElement>) {
    // react-markdown types href as optional. A link without an href can't navigate anywhere,
    // so just render its text.
    if (!href) return <>{children}</>;

    return (
        <InlineLink href={href} target={target as LinkTarget | undefined} underline="none" className={linkStyles}>
            {children}
        </InlineLink>
    );
}
